import { render, staticRenderFns } from "./ProductIngredients.vue?vue&type=template&id=6f6585e6&scoped=true"
import script from "./ProductIngredients.vue?vue&type=script&lang=js"
export * from "./ProductIngredients.vue?vue&type=script&lang=js"
import style0 from "./ProductIngredients.vue?vue&type=style&index=0&id=6f6585e6&prod&scoped=true&lang=css"
import style1 from "./ProductIngredients.vue?vue&type=style&index=1&id=6f6585e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6585e6",
  null
  
)

export default component.exports